import React from 'react';
import './index.scss';

//api
import { api } from '../../../../../functions/api'

//custom components
import CustomButton from '../../../../../components/basic/CustomButton';
import CustomIconButton from '../../../../../components/basic/customIconButton';
import CustomInput from '../../../../../components/basic/input';
import DeleteDialog from '../../../../../components/global/deleteDialog';

//material-ui
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField'
import { Table, TableHead, TableBody, TableRow, TableCell, InputBase } from '@material-ui/core';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

//other libraries
import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';
import Icon from '@mdi/react'
import { mdiClose, mdiDotsVertical } from '@mdi/js'
// import dateformat from 'dateformat'
import moment from 'moment';


const theme = createMuiTheme({
  typography: {
    useNextVariants: true
  },
  overrides: {
    MuiDialog: {
      paper: {
        overflow: "hidden !important"
      }
    },
    MuiPaper: {
      root: {
        overflow: "hidden"
      },

    }
  },
  confirmationDialog: false
})
@inject('translate')
@inject('internal')
@observer
export default class OrderDetail extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      loading: false,
      openSnackbar: false,
      message: "",
      data: {}
    }
  }

  componentDidMount () {
    this.loadClientOrders();
    // nastavenie precitania notifikacii
    const {user} = toJS(this.props.internal)
    if (user && user.data && user.data.role && (user.data.role.id === 3 || user.data.role.id === 4)) {
      let idOrder = toJS(this.props.idOrder)
      let nots = toJS(this.props.internal.user.data.notifications)
      let setReadNotifi = null
      nots.filter(function (item) {
        let tmp = item.data.uri
        if (tmp.includes(idOrder)) {
          setReadNotifi = item.id
        }
      })
      this.setReadNotification(setReadNotifi)
    }

  }

  componentWillReceiveProps () {
    // this.loadClientOrders();
  }

  tmpTableData = [];
  loadClientOrders = async () => {
    this.setState({loading: true})
    let idClient = toJS(this.props.routerData.match.params.idClient)
    let idOrder = toJS(this.props.internal.actionEdit.id) ? toJS(this.props.internal.actionEdit.id) : this.props.routerData.match.params.id

    /**
     * @rs
     * 03.09.2019
     * fixed => this api call should only be fetched if there are both IDs,
     * invalid IDs are causing changes in pathname (ID is removed).
     * TODO:
     * Also, this is called like milion times, should be fixed..
     */
    if(idClient && idOrder) {
      let load_data = await api({
        method: 'get',
        url: 'clients/' + idClient + '/orders/' + idOrder,
        authorization: this.props.internal.user.access_token,

      })

      if (load_data.success === true) {
        Object.assign(this.tmpTableData, load_data.data.data);
        this.setState({data: load_data.data.data})
        // this.setState({loading: false})
      } else if (load_data.success === false) {
        this.props.showSnackbar(load_data.data.message, true, true)
        // this.setState({loading: false})
      }

      // tlacidlo na mazanie produktu z objednavky povolene iba ked objednavka nieje schvalena/zrusena
      if (load_data.data.data.approved === false && load_data.data.data.denied === false) {
        this.detail.push(
          {
            title: this.props.translate.i18n.GLOBAL.BUTTONS.DELETE,
            action: "delete"
          },
        )
      }
    }

    this.setState({loading: false})
  }

  handleClose = () => {
    let data = {
      edit: false,
      id: null
    }
    this.props.internal.setActionEdit(data);
  }

  formatMoney = (data) => {
    const formatter = new Intl.NumberFormat('sk-SK', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2
    })
    return formatter.format(data)
  }

  handleActionOrder = async (confirmed) => {

    let idClient = this.props.routerData.match.params.idClient
    let idOrder = this.tmpTableData.id

    this.setState({loading: true})

    let url = 'clients/' + idClient + '/orders/' + idOrder;
    if (confirmed) {
      url += '/approve'
    } else {
      url += '/deny'
    }

    let load_data = await api({
      method: 'patch',
      url: url,
      authorization: this.props.internal.user.access_token,
      params: {
        confirmed: confirmed,
        note: this.note.state.value
      }
    })

    let nots = toJS(this.props.internal.user.data.notifications)
    let setReadNotifi = null
    nots.filter(function (item) {
      let tmp = item.data.uri
      if (tmp.includes(idOrder)) {
        setReadNotifi = item.id
      }
    })
    if (load_data.success === true) {
      let notificationId = toJS(this.props.internal.notifiId)
      this.setReadNotification(setReadNotifi);
      if (notificationId !== null) {
        this.setReadNotification(notificationId);
      }

      this.setState({loading: false, confirmationDialog: false})
      let actionEdit = {
        edit: false,
        id: null
      };
      this.props.internal.setActionEdit(actionEdit)
      this.props.showSnackbar(load_data.data.message, true)
      this.props.internal.pushRoute(`/clients/${idClient}/orders`)
    }
  }

  setReadNotification = async (id) => {
    let set_data = await api({
      method: 'patch',
      url: `user/notifications/${id}/read`,
      authorization: this.props.internal.user.access_token,
    })

    if (set_data.success) {
      this.getUserData();
    }
  }

  getUserData = async () => {
    let load_data = await api({
      method: 'get',
      url: 'user',
      authorization: this.props.internal.user.access_token,
    })

    if (load_data.success === true) {
      localStorage.setItem("user", JSON.stringify(load_data.data),)
      this.props.internal.loginUser(load_data.data, true)
    }
  }

  detail = [
    {
      title: this.props.translate.i18n.GLOBAL.BUTTONS.DETAIL,
      action: "detail"//detail objednavky
    },
    // {
    //     title: this.props.translate.i18n.GLOBAL.BUTTONS.DELETE,
    //     action: "delete"
    // },
  ]

  handleDelete = async () => {
    this.setState({loadingBtn: true})
    let client_id = this.props.routerData.match.params.idClient
    let order_id = this.props.routerData.match.params.id
    let product_id = toJS(this.props.internal.actionDeleteObj.id)


    let delete_data = await api({
      method: 'DELETE',
      url: `clients/${client_id}/orders/${order_id}/product-remove`,
      authorization: this.props.internal.user.access_token,
      params: {
        product_id: product_id
      }
    })

    if (delete_data.success === true) {
      this.props.internal.setSnackbar(delete_data.data.message, true)
      this.props.internal.setActionDeleteObj(
        {
          module: null,
          id: null
        }
      )

      this.props.internal.setActionDelete()
      this.loadClientOrders()
    } else {
      this.props.internal.setSnackbar(delete_data.data.message, true)
    }
    this.setState({loadingBtn: false})
  }

  timeout2 = null
  handleChangeQuantity = (item, val) => {
    let quantity = val.target.value
    clearTimeout(this.timeout2)
    this.timeout2 = setTimeout(() => {
      this.updateQuantity(item, quantity)
    }, 1000)
  }

  updateQuantity = async (item, quantity) => {

    let client_id = this.props.routerData.match.params.idClient
    let order_id = this.props.routerData.match.params.id
    let product_id = item.product_id

    let update_data = await api({
      method: 'PATCH',
      url: `clients/${client_id}/orders/${order_id}/product-quantity`,
      authorization: this.props.internal.user.access_token,
      params: {
        product_id: product_id,
        quantity: quantity
      }
    })

    if (update_data.success === true) {
      this.props.internal.setSnackbar(update_data.data.message, true)
      this.tmpTableData = []
      Object.assign(this.tmpTableData, update_data.data.data);
      this.setState({data: update_data.data.data})
    }
  }


  render () {

    let status;
    if (Object.keys(this.tmpTableData).length !== 0) {
      status = (this.tmpTableData.status).toUpperCase()
    }

    return (
      // this.state.loading
      //     ?
      //     <CircularProgress className={'circular-progress'} />
      //     :
      //     Object.keys(this.tmpTableData).length !== 0 ?
      //     <div>

      <MuiThemeProvider theme={theme}>
        {(toJS(this.props.internal.actionEdit.edit === true)) && (toJS(this.props.internal.actionDelete === true)) &&
        <DeleteDialog
          open={this.props.internal.actionDelete}
          title={this.props.translate.i18n.MODULES['CUSTOMERS-ORDERS'].DELETE_ITEM}
          content={this.props.translate.i18n.GLOBAL.ALERTS.DELETE_ITEM}
          btn_cancel={this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
          btn_delete={this.props.translate.i18n.GLOBAL.BUTTONS.DELETE}
          delete={this.handleDelete}
        />
        }
        <Dialog
          open={this.props.open}
          onClose={this.props.onClose}
          aria-labelledby="form-dialog-title"
          className={'detail-order'}
          maxWidth={'lg'}
        >
          <div className={'dialog-title flex space-between'}>
            <h2>
              {this.props.translate.i18n.MODULES.CLIENTS.ORDER} {this.state.loading ? "" : this.tmpTableData.order_id}
            </h2>
            <div className={'close'} onClick={this.props.onClose}>
              <Icon path={mdiClose} size={1}/>
            </div>
          </div>
          <DialogContent className={'dialog-order-detail'}>
            {this.state.loading
              ?
              <CircularProgress className={'circular-progress'}/>
              :
              Object.keys(this.tmpTableData).length !== 0 ?
                <div>
                  {/* <CustomSnackbar message={this.props.internal.dataSnackbar.msg} open={this.props.internal.dataSnackbar.open} classes={'snackbar-for-dialog'}/> */}
                  <div className={'basic-info'}>
                    <TextField
                      id="branch"
                      label={this.props.translate.i18n.MODULES.CLIENTS.BRANCH}
                      value={this.tmpTableData.branch ? this.tmpTableData.branch.name : ""}
                      margin="normal"
                      disabled
                      className={'item'}
                    />
                    <TextField
                      id="status"
                      label={this.props.translate.i18n.MODULES.CLIENTS.STATUS}
                      value={this.props.translate.i18n.MODULES.CLIENTS.OREDER_STATE[status]}
                      margin="normal"
                      disabled
                      className={'item'}
                    />
                    <TextField
                      id="creeated"
                      label={this.props.translate.i18n.MODULES.CLIENTS.CREATED_AT}
                      // value={dateformat(this.tmpTableData.created_at, "dd.mm.yyyy HH:MM")}
                      value={moment(this.tmpTableData.created_at).format("DD.MM.YYYY HH:mm")}
                      margin="normal"
                      disabled
                      className={'item'}
                    />
                    <TextField
                      id="transport"
                      label={this.props.translate.i18n.MODULES.CLIENTS.TRANSPORT}
                      value={this.tmpTableData.delivery_type.name ? this.tmpTableData.delivery_type.name : ""}
                      margin="normal"
                      disabled
                      className={'item auto-width'}
                      // multiline
                      // rowsMax={1}
                    />
                    <TextField
                      id="transport_price"
                      label={this.props.translate.i18n.MODULES.CLIENTS.TRANSPORT_PRICE}
                      value={this.tmpTableData.delivery_type_price >= 0 ? this.formatMoney(this.tmpTableData.delivery_type_price) : ""}
                      margin="normal"
                      disabled
                      className={'item'}
                      inputProps={{style: {textAlign: "right"}}}
                    />
                    <TextField
                      id="created_order"
                      label={this.props.translate.i18n.MODULES.CLIENTS.CREATE_ORDER}
                      value={this.tmpTableData.creator.username ? this.tmpTableData.creator.username : ""}
                      margin="normal"
                      disabled
                      className={'item'}
                    />
                    <TextField
                      id="approved_by"
                      label={this.props.translate.i18n.MODULES.CLIENTS.APPROVED_BY}
                      // value={
                      //     this.tmpTableData.approved_by && this.tmpTableData.approved_by !== null || this.tmpTableData.denied_by && this.tmpTableData.denied_by !== null
                      //         ?
                      //         this.tmpTableData.denied_by.username || this.tmpTableData.approved_by.username
                      //             ?
                      //             this.tmpTableData.denied_by.username ? this.tmpTableData.denied_by.username : "N/A"
                      //             :
                      //             this.tmpTableData.approved_by.username ? this.tmpTableData.approved_by.username : "N/A"
                      //         :
                      //          "N/A"
                      //     }
                      value={
                        (this.tmpTableData.approved_by && this.tmpTableData.approved_by !== null) || (this.tmpTableData.denied_by && this.tmpTableData.denied_by !== null)
                          ?
                          this.tmpTableData.denied_by && this.tmpTableData.denied_by.username !== null
                            ?
                            this.tmpTableData.denied_by.username
                            :
                            this.tmpTableData.approved_by && this.tmpTableData.approved_by.username !== null
                              ?
                              this.tmpTableData.approved_by.username
                              :
                              "N/A"
                          :
                          "N/A"
                      }
                      margin="normal"
                      disabled
                      className={'item'}
                    />
                    <TextField
                      id="approved_by"
                      label={this.props.translate.i18n.MODULES.CLIENTS.DATE_APPROVED}
                      // value={this.tmpTableData.approved_at ? dateformat(this.tmpTableData.approved_at, "dd.mm.yyyy HH:MM"): "N/A"}
                      value={this.tmpTableData.approved_at ? moment(this.tmpTableData.approved_at).format("DD.MM.YYYY HH:mm") : "N/A"}
                      margin="normal"
                      disabled
                      className={'item'}
                    />
                    <TextField
                      id="date_approved"
                      label={this.props.translate.i18n.MODULES.CLIENTS.PAYMENT_TYPE}
                      value={this.tmpTableData.payment_type.name ? this.tmpTableData.payment_type.name : ""}
                      margin="normal"
                      disabled
                      className={'item auto-width'}
                      // multiline
                      // rowsMax={1}
                    />
                    <TextField
                      id="payment"
                      label={this.props.translate.i18n.MODULES.CLIENTS.PAYMENT_PRICE}
                      value={this.tmpTableData.payment_type_price >= 0 ? this.formatMoney(this.tmpTableData.payment_type_price) : ""}
                      margin="normal"
                      disabled
                      className={'item'}
                      inputProps={{style: {textAlign: "right"}}}
                    />
                  </div>
                  <div style={{overflow: 'auto'}}>
                    <Table className={'table-detail-order'}>
                      <TableHead>
                        <TableRow>
                          <TableCell></TableCell>
                          <TableCell>{this.props.translate.i18n.MODULES.PRODUCTS.CODE}</TableCell>
                          <TableCell>{this.props.translate.i18n.MODULES.PRODUCTS.NAME}</TableCell>
                          <TableCell>{this.props.translate.i18n.MODULES.CLIENTS.PIECES}</TableCell>
                          <TableCell>{this.props.translate.i18n.MODULES.CLIENTS.PRICE_FOR_ONE_ITEM}</TableCell>
                          <TableCell>{this.props.translate.i18n.MODULES.PRODUCTS.VAT}</TableCell>
                          <TableCell>{this.props.translate.i18n.MODULES.CLIENTS.TOTAL_PRICE_WITHOUT_VAT}</TableCell>
                          <TableCell>{this.props.translate.i18n.MODULES.CLIENTS.TOTAL_PRICE_WITH_VAT}</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {this.tmpTableData.items.map((item, index) => {
                          if (null === item.product) return null;
                          return ( // @todo: check production t|f to color shit up ..
                            <TableRow key={item.product_id}>
                              <TableCell className={'first-cell'} style={{'width': '50px',}}>
                                <CustomIconButton
                                  id={item.product_id}
                                  label="More"
                                  dropdownMenu
                                  items={this.detail}
                                  module={'/products'}
                                  production={item.product.production}
                                  backToOrderDetail
                                  aboutItem={item}
                                  data={item}
                                >
                                  <Icon path={mdiDotsVertical} size={1}/>
                                </CustomIconButton>
                              </TableCell>
                              <TableCell>{item.product.code}</TableCell>
                              <TableCell>{item.product.name}</TableCell>
                              {/* <TableCell>{item.quantity}</TableCell> */}
                              <TableCell>
                                {this.tmpTableData.approved === false && this.tmpTableData.denied === false ?
                                  <InputBase type={'number'}
                                             inputProps={{
                                               min: 1
                                             }}
                                             defaultValue={item.quantity} onChange={(val) => this.handleChangeQuantity(item, val)}/>
                                  :
                                  item.quantity
                                }
                              </TableCell>
                              <TableCell numeric>{this.formatMoney(item.one_price)}</TableCell>
                              <TableCell numeric>{item.product.vat}%</TableCell>
                              <TableCell numeric>{this.formatMoney(item.total_price)}</TableCell>
                              <TableCell numeric>{this.formatMoney(item.total_price_with_vat)}</TableCell>
                            </TableRow>
                          )
                        })}
                      </TableBody>
                    </Table>
                  </div>
                  <div className={'flex basic-info notes'}>
                    <div className={'width-50'}>
                      <TextField
                        id="order-number"
                        label={this.props.translate.i18n.MODULES.CLIENTS.WRITE_ORDER_NUMBER}
                        value={this.state.data.order_number !== null ? this.state.data.order_number : "N/A"}
                        disabled
                        className={'item w-100'}
                        multiline={true}
                        classes={{
                          root: "textFieldDisabled",
                        }}
                      />

                      <TextField
                        id="note"
                        label={this.props.translate.i18n.MODULES.CLIENTS.NOTE_CLIENT}
                        value={this.state.data.client_note !== null ? this.state.data.client_note : "N/A"}
                        disabled
                        margin={"normal"}
                        className={'item w-100'}
                        multiline={true}
                        classes={{
                          root: "textFieldDisabled",

                        }}
                      />
                    </div>
                    <div className={'width-50'}>
                      <TextField
                        id="delivery-date"
                        label={this.props.translate.i18n.MODULES.CLIENTS.WRITE_DELIVERY_DATE}
                        value={this.state.data.delivery_date !== null ? moment(this.state.data.delivery_date).format('DD.MM.YYYY') : "N/A"}
                        disabled
                        className={'item w-100'}
                        multiline={true}
                        classes={{
                          root: "textFieldDisabled",
                        }}
                      />
                      {this.state.data.approved === false && this.state.data.denied === false ?
                        // toJS(this.props.internal.user.data.role.id) < 3 ?
                        toJS(this.props.internal.user.data.permissions.clients_orders.approve) ?
                          <CustomInput
                            ref={ref => this.note = ref}
                            text={this.props.translate.i18n.MODULES.CLIENTS.NOTE_ADMIN}
                            id={'note'}
                            className={`note w-100`}
                            multiline={true}
                          />
                          :
                          <TextField
                            id="note"
                            label={this.props.translate.i18n.MODULES.CLIENTS.NOTE_ADMIN}
                            value={this.state.data.note !== null ? this.state.data.note : "N/A"}
                            margin="normal"
                            disabled
                            className={'item w-100'}
                            multiline={true}
                          />
                        :
                        <TextField
                          id="note"
                          label={this.props.translate.i18n.MODULES.CLIENTS.NOTE_ADMIN}
                          value={this.state.data.note !== null ? this.state.data.note : "N/A"}
                          margin="normal"
                          disabled
                          className={'item w-100'}
                          multiline={true}
                        />
                      }
                    </div>
                  </div>
                  <div className={'footer flex space-between'}>
                    {/* {Number(toJS(this.props.internal.user.data.permissions.clients_orders.approve)) <= 2 ? */}
                    {toJS(this.props.internal.user.data.permissions.clients_orders.approve) ?
                      <div className={`btns ${this.tmpTableData.approved === false && this.tmpTableData.status === "new" ? '' : 'hidden'}`}>

                        <CustomButton
                          progressBar={this.state.loadingBtn}
                          onClick={() => this.setState({confirmationDialog: true})}
                          mystyle={'btn-white-bg-red-text'}
                          title={this.props.translate.i18n.MODULES.CLIENTS.CANCEL_ORDER}
                          justText
                        />
                        <CustomButton
                          progressBar={this.state.loadingBtn}
                          onClick={() => this.handleActionOrder(true)}
                          mystyle={'btn-white-bg'}
                          title={this.props.translate.i18n.MODULES.CLIENTS.APPROVE_ORDER}
                          justText
                        />

                      </div>
                      :
                      null
                    }
                    <div className={'summary'}>
                      <div className={'flex with-vat'}>
                        <p>{this.props.translate.i18n.MODULES.CLIENTS.TOTAL_PRICE_WITHOUT_VAT}</p>
                        <span>{this.formatMoney(this.tmpTableData.total)}</span>
                      </div>
                      {(this.tmpTableData.cent_correction !== null) ? <div className={'flex without-vat'}>
                        <p>{this.props.translate.i18n.MODULES.CLIENTS.CENT_CORRECTION}</p>
                        <span>{this.formatMoney(this.tmpTableData.cent_correction)} </span>
                      </div> : null}
                      <div className={'flex without-vat'}>
                        <p>{this.props.translate.i18n.MODULES.CLIENTS.TOTAL_PRICE_WITH_VAT}</p>
                        <span>{this.formatMoney(this.tmpTableData.total_with_vat)} </span>
                      </div>
                    </div>
                  </div>
                </div>
                :
                null
            }
          </DialogContent>

        </Dialog>
        {/*
        @rs
        added confirmation dialog for order cancellation
        */}
        <Dialog
          open={!!this.state.confirmationDialog}
          onClose={() => {
            if(!!this.state.confirmationDialog) {
              this.setState({
                confirmationDialog: false
              })
            }
          }}
          aria-labelledby='confirmation-dialog'
          maxWidth={'lg'}>
            <DialogContent
              className={`confirmation-dialog`}>
                <div className={`flex w-100`} style={{marginBottom: '2em', textAlign: 'center', justifyContent: 'center', marginTop: '1em', paddingLeft: '1.5em', paddingRight: '1.5em'}}>
                  {this.props.translate.i18n.MODULES.CLIENTS.CONFIRM_CANCEL_ORDER}
                </div>
                <div className={`footer flex space-between`}>
                  <CustomButton
                    progressBar={this.state.loadingBtn}
                    onClick={() => this.setState({confirmationDialog: false})}
                    mystyle={'btn-white-bg gray-text'}
                    title={this.props.translate.i18n.GLOBAL.BUTTONS.BACK}
                    justText
                  />
                  <CustomButton
                    progressBar={this.state.loadingBtn}
                    onClick={() => this.handleActionOrder(false)}
                    mystyle={'btn-white-bg-red-text'}
                    title={this.props.translate.i18n.MODULES.CLIENTS.CANCEL_ORDER}
                    justText
                  />
                </div>
            </DialogContent>
        </Dialog>
      </MuiThemeProvider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/clients/detail/orders/detail/index.js